export default __webpack_public_path__ + "static/media/img1.39ece553.png";